import React from 'react';
import { useSelector } from 'react-redux';

import { getArea } from 'core/selectors';

import { Partners } from './Partners';

export const Container = () => {
  const { partners } = useSelector(getArea);

  if (!partners.length) {
    return null;
  }

  return <Partners data={partners} />;
};
